﻿import { ApiCaller } from 'apis/ApiCaller';

export interface State{
	Id: number;
	Name: string;
}

export class StateApi {

    private static apiCaller = new ApiCaller('State');

    public static GetAll(countryId: number) : Promise<State[]> {

	    return this.apiCaller.GET<State[]>('GetAll', { countryId });

    }

}